import { connect, Component } from "macguffin"
import { pickLandingZone, setFreespinSummaryComplete, winCountUpStep, winCountUpLevel } from "game/redux/actions"

import BackgroundImage from "utils/BackgroundImage"

import GameMode from "game/modes"

import SummaryLine from "./SummaryLine"
import JackpotLine from "./JackpotLine"
import TotalLine from "./TotalLine"

import LandingZone from "./LandingZone"

import { Tween } from "@tweenjs/tween.js"

const { assign } = Object
const { floor, random } = Math

const LETTERS = ["A", "B", "C", "D"]
const LANDING_ZONE_SCALE = 0.18
const LANDING_ZONE_OFFSET = 20

const SUMMARY_LABEL_FONT_SCALE = 0.05
const SUMMARY_VALUE_FONT_SCALE = 0.06
const SUMMARY_CASH_FONT_SCALE = 0.08
const SUMMARY_JACKPOT_FONT_SCALE = 0.09
const SUMMARY_TOTAL_FONT_SCALE = 0.12

const AUTOPICK_TIMEOUT = 15 * 60 * 1000 //15 minute timeout

const marsBackgroundStyle = {
    backgroundPosition: "bottom center",
    backgroundSize: "cover"
}

const smokeStyle1 = {
    backgroundRepeat: "repeat-x",
    backgroundPosition: "left bottom",
    backgroundSize: "auto"
}

const landerBodyStyle = {
    backgroundPosition: "top center",
    backgroundSize: "contain"
}

const shadowStyle = {
    transform: "translate(-50%, 48%) perspective(100px) rotateX(-30deg) scale(0)",
    opacity: 0,
    backgroundPosition: "top center",
    backgroundSize: "contain"
}

const landerStyle = {
    transform: "translateY(-100vh)",
}

const landerLegsStyle = {
    transform: "translate(-50%, -50%) scale(0.5)",
    backgroundPosition: "center center",
    backgroundSize: "contain"
}

function getSummaryLines(props, showNextLine, summaryCountUpComplete) {
    const { width, height, jackpotDraw = {}, winCountUpStep } = props
    const { runningTotal = 0, fuelWin = 0, finalStageWin = 0, jackpotWin = 0 } = jackpotDraw

    let totalWin = runningTotal + fuelWin + finalStageWin

    const startScale = 1.5
    const animationName = "revealText"
    const transform = "scale(1.5)"

    //create some shared properties
    const sharedStyle = { animationName, opacity: 0, transform }

    //create specific properties and copy the shared attributes
    const labelStyle = assign({ fontSize: `${height * SUMMARY_LABEL_FONT_SCALE}px` }, sharedStyle)
    const valueStyle = assign({ fontSize: `${height * SUMMARY_VALUE_FONT_SCALE}px` }, sharedStyle)
    const cashStyle = assign({ fontSize: `${height * SUMMARY_CASH_FONT_SCALE}px` }, sharedStyle)
    const jackpotLogoStyle = assign({ position: "relative", width: `${width * 0.5}px`, height: `${height * 0.1}px` }, sharedStyle)
    const jackpotStyle = assign({ fontSize: `${height * SUMMARY_JACKPOT_FONT_SCALE}px` }, sharedStyle)
    const totalStyle = assign({ fontSize: `${height * SUMMARY_TOTAL_FONT_SCALE}px` }, sharedStyle)

    const summaryLines = []
    //runningTotal
    summaryLines.push(<SummaryLine
        key = "runningTotal"
        labelStyle = {labelStyle}
        valueStyle = {valueStyle}
        label = {"freespins.jackpotDraw.runningTotal"}
        value = {runningTotal}
        onCountUpComplete = {showNextLine}
        duration = {2000}
        winCountUpStep = {winCountUpStep}
    />)

    // //fuel win
    if (fuelWin) {
        summaryLines.push(<SummaryLine
            key = "fuelWin"
            labelStyle = {labelStyle}
            valueStyle = {valueStyle}
            label = {"freespins.jackpotDraw.fuelWin"}
            value = {fuelWin}
            onCountUpComplete = {showNextLine}
            duration = {2000}
            winCountUpStep = {winCountUpStep}
        />)
    }

    // //final stage win
    summaryLines.push(<SummaryLine
        key = "finalStageWin"
        labelStyle = {cashStyle}
        valueStyle = {cashStyle}
        label = {"freespins.jackpotDraw.finalStageWin"}
        value = {finalStageWin}
        onCountUpComplete = {showNextLine}
        duration = {2000}
        winCountUpStep = {winCountUpStep}
    />)

    // //jackpot
    if (jackpotWin) {
        totalWin += jackpotWin
        summaryLines.push(<JackpotLine
            key = "jackpot"
            jackpotStyle = {jackpotLogoStyle}
            valueStyle = {jackpotStyle}
            value = {jackpotWin}
            onCountUpComplete = {showNextLine}
            duration = {4000}
            winCountUpStep = {winCountUpStep}
        />)
    }

    //total
    summaryLines.push(<TotalLine
        key = "summaryTotal"
        labelStyle = {jackpotStyle}
        valueStyle = {totalStyle}
        label = {"freespins.jackpotDraw.finalResult"}
        value = {totalWin}
        onCountUpComplete = {summaryCountUpComplete}
        duration = {jackpotWin ? 6000 : 4000}
        winCountUpStep = {winCountUpStep}
    />)

    return summaryLines
}

@connect(state => ({
    autoPick: state.base.settings.autoPick,
    currentGameMode: state.game.currentGameMode,
    currentFreespins: state.game.currentFreespins,
    jackpotDraw: state.game.jackpotDraw,
    jackpot: state.game.jackpot,
    globalPaused: state.base.paused
}), {
    pickLandingZone,
    setFreespinSummaryComplete,
    winCountUpStep,
    winCountUpLevel
})
export default class Mars extends Component {
    constructor() {
        super()
        this.state = {}
    }

    componentWillUnmount() {
        const lander = document.getElementById("marsLander")
        lander.removeEventListener("animationend", this.onLand, false)
    }

    componentWillReceiveProps(newProps) {
        const currentProps = this.props

        if (newProps.currentGameMode !== currentProps.currentGameMode && newProps.currentGameMode === GameMode.MARS_INTRO) {
            const marsStyle = {
                opacity: 0,
                animationName: "revealMars"
            }

            this.setState({ marsStyle })
        }

        if (newProps.jackpotDraw !== currentProps.jackpotDraw) {
            if (newProps.jackpotDraw) {
                this.showDrawResult(newProps.jackpotDraw)
            } else {
                this.setState({
                    landingZonesStyle: { opacity: 1},
                    landerAnimation: undefined,
                    shadowAnimation: undefined,
                    legsAnimation: undefined,
                    currentLineIndex: undefined,
                    selectedZone: undefined,
                    marsStyle: undefined,
                    prizes: undefined
                })
            }
        }

        if (newProps.showMars && newProps.showMars !== currentProps.showMars) {
            this.timeout && this.timeout.stop()
            this.timeout = new Tween()
                .to({}, AUTOPICK_TIMEOUT)
                .onComplete(() => {
                    this.onSelect(Math.floor(Math.random() * 4))
                })
                .start()
        }

        if (!newProps.autoPick && newProps.autoPick !== currentProps.autoPick) {
            this.timeout && this.timeout.stop()
            this.timeout = undefined
        }
    }

    showDrawResult = (jackpotDraw) => {
        const { state: { selectedZone }, startSummary } = this
        const { jackpotWon, finalStageWin, jackpotWin } = jackpotDraw
        const prizes = new Array(4).fill(finalStageWin)

        if (jackpotWon) {
            prizes[selectedZone] = "JACKPOT"
        } else {
            let randomIndex = selectedZone
            while (randomIndex === selectedZone) {
                randomIndex = floor(random() * 4)
            }
            prizes[randomIndex] = "JACKPOT"
        }

        this.setState({ prizes }, startSummary)
    }

    startSummary = () => {
        const { props, showNextLine, summaryCountUpComplete, startLandingSequence } = this
        const summaryLines = getSummaryLines(props, showNextLine, summaryCountUpComplete)
        this.setState({ summaryLines }, startLandingSequence)
    }

    startLandingSequence = () => {
        const lander = document.getElementById("marsLander")
        lander.addEventListener("animationend", this.onLand, false)

        const landingZonesStyle = {
            opacity: 0
        }

        this.setState({
            landerAnimation: "land",
            shadowAnimation: "showShadow",
            legsAnimation: "showLegs",
            landingZonesStyle
        })
    }

    onLand = () => {
        const lander = document.getElementById("marsLander")
        lander.removeEventListener("animationend", this.onLand, false)

        this.setState({ currentLineIndex: 0 })
    }

    showNextLine = () => {
        const { props, state } = this
        const { currentLineIndex = -1 } = state

        const nextLineIndex = currentLineIndex + 1
        props.winCountUpLevel(Math.min(nextLineIndex, 3))

        this.setState({ currentLineIndex: nextLineIndex })
    }

    summaryCountUpComplete = () => {
        const { props } = this
        const { setFreespinSummaryComplete } = props
        props.winCountUpLevel(3)
        setFreespinSummaryComplete()
    }

    renderSummary = () => {
        const { state } = this
        const { summaryLines, currentLineIndex = -1 } = state

        return <div>
            {
                summaryLines && summaryLines.map((summaryLine, index) => {
                    return (index <= currentLineIndex) && summaryLine
                })
            }
        </div>
    }

    onSelect = (index) => {
        const { props: { pickLandingZone }, timeout } = this
        const callback = () => { pickLandingZone() }

        timeout && timeout.stop()
        this.timeout = undefined

        this.setState({ selectedZone: index }, callback)
    }

    renderLandingZones = () => {
        const { props : { width, height, jackpotDraw }, state : { prizes, selectedZone }, onSelect } = this
        const { jackpotWin } = jackpotDraw || {}

        const pickWidth = width * LANDING_ZONE_SCALE
        const pickHeight = height * LANDING_ZONE_SCALE

        const picks = []
        for (let i = 0; i < 4; i++) {
            const prize = prizes && prizes[i]
            const left = (i + 1) * LANDING_ZONE_OFFSET
            picks.push(<LandingZone
                key={`LandingZone${i}`}
                index={i}
                left={left}
                width={pickWidth}
                height={pickHeight}
                letter={LETTERS[i]}
                selected={selectedZone}
                onSelect={isNaN(selectedZone) && onSelect}
                prize={prize}
            />)
        }

        return picks
    }

    render() {
        const { props, state, renderLandingZones } = this
        const { width, height, visibility, globalPaused } = props

        const {
            currentLineIndex,
            selectedZone,
            marsStyle,
            landingZonesStyle,
            landerAnimation,
            legsAnimation,
            shadowAnimation
        } = state || {}

        const animationPlayState = globalPaused ? "paused" : "running"

        const shadowAnimationProperties = !globalPaused ? {
            animationName: shadowAnimation,
            animationPlayState
        } : {}

        const landerAnimationProperties = !globalPaused ? {
            animationName: landerAnimation,
            animationPlayState
        } : {}

        const legsAnimationProperties = !globalPaused ? {
            animationName: legsAnimation,
            animationPlayState
        } : {}

        const left = !isNaN(selectedZone) ? `${(selectedZone + 1) * LANDING_ZONE_OFFSET}%` : "99.9%"
        const size = {
            width: `${height * 0.3}px`,
            height: `${height * 0.3}px`
        }

        const summaryStyle = {
            width: `${width}px`,
            height: `${height}px`,
            left: (window.innerWidth - width) / 2,
            top: (window.innerHeight - height) / 2,
            opacity: !isNaN(currentLineIndex) ? 1 : 0,
            backgroundPosition: "center center",
            backgroundSize: "100% 100%"
        }

        return <div id="mars" key="marsContainer" style={{...marsStyle, visibility, animationPlayState}}>
            <BackgroundImage className="marsBackground" assetName="marsBackground" style={marsBackgroundStyle}/>
            <BackgroundImage className="marsBackgroundSmoke" assetName="marsSmoke1" style={{...smokeStyle1, animationPlayState}}/>
            <div className="marsLandingZones" style={{...landingZonesStyle, animationPlayState}}>
                { renderLandingZones() }
            </div>
            <BackgroundImage className="marsLanderShadow" assetName="landerBody" style={{...shadowStyle, ...size, left, ...shadowAnimationProperties}}/>
            <div id="marsLander" style={{...landerStyle, ...size, left, ...landerAnimationProperties}}>
                <BackgroundImage className="marsLanderLegs" assetName="landerLegs" style={{...landerLegsStyle, ...legsAnimationProperties}}/>
                <BackgroundImage className="marsLanderBody" assetName="landerBody" style={landerBodyStyle}/>
            </div>
            <BackgroundImage className="marsForegroundSmoke" assetName="marsSmoke2" style={{...smokeStyle1, animationPlayState}}/>
            <BackgroundImage className="marsSummaryScreen" assetName="marsSummaryPanel" style={summaryStyle}>
                { this.renderSummary() }
            </BackgroundImage>
        </div>
    }
}

